import { c as _c } from "react/compiler-runtime";
import { Button, Flex, Heading, Image, Stack, Text, VStack } from '@chakra-ui/react';
import { getTrackPathPrefix } from '@src/components/sco/Education/ContentTrackContext';
import { ChevronRightIcon } from '@src/components/sco/icons';
import { FadeRevealWithSSR } from '@src/components/sco/ssr-transitions/FadeRevealWithSSR';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ContentTrack } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import { useHover } from '@uidotdev/usehooks';
type ContentTrackCardProps = {
  contentTrack: ContentTrack;
  vertical?: boolean;
  direction?: any;
  bgDir?: any;
  bgColor?: string;
  fadeDir?: string;
  fadeStartColor?: string;
  fadeEndColor?: string;
};
export const ContentTrackCard = props => {
  const $ = _c(66);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const [ref] = useHover();
  const t0 = props.fadeDir;
  const t1 = `${props.contentTrack.color?.hex}10 0%`;
  const t2 = `${props.contentTrack.color?.hex}50`;
  const t3 = props.direction;
  let t4;
  if ($[0] !== getBreakpointValue) {
    t4 = getBreakpointValue([true, true, true, false]);
    $[0] = getBreakpointValue;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = props.contentTrack.featuredImage?.url;
  let t6;
  if ($[2] !== t5) {
    t6 = <Image maxHeight="30em" objectFit="contain" src={t5} transition="all 0.1s ease-in" zIndex={1} />;
    $[2] = t5;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t4 || $[5] !== t6) {
    t7 = <Flex align="center" flex={2} hidden={t4} justify="center" padding={20} position="relative">{t6}</Flex>;
    $[4] = t4;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== getBreakpointValue) {
    t8 = getBreakpointValue([10, 10, 20, 20, 20]);
    $[7] = getBreakpointValue;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== getBreakpointValue) {
    t9 = getBreakpointValue([10, 10, 20, 24, 24]);
    $[9] = getBreakpointValue;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== getBreakpointValue) {
    t10 = getBreakpointValue(["3xl", "3xl", "4xl", "5xl"]);
    $[11] = getBreakpointValue;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== props.contentTrack.title || $[14] !== t10) {
    t11 = <Heading size={t10}>{props.contentTrack.title}</Heading>;
    $[13] = props.contentTrack.title;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== getBreakpointValue) {
    t12 = getBreakpointValue(["md", "lg", "xl", "lg"]);
    $[16] = getBreakpointValue;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== props.contentTrack.shortDescription || $[19] !== t12) {
    t13 = <Text fontFamily="longform" fontSize={t12} opacity={0.75}>{props.contentTrack.shortDescription}</Text>;
    $[18] = props.contentTrack.shortDescription;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t11 || $[22] !== t13) {
    t14 = <VStack align="flex-start" gap={4}><FadeRevealWithSSR cascade={true} damping={0.5} direction="up" duration={500} triggerOnce={true}>{t11}{t13}</FadeRevealWithSSR></VStack>;
    $[21] = t11;
    $[22] = t13;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== props.contentTrack) {
    t15 = getTrackPathPrefix(props.contentTrack);
    $[24] = props.contentTrack;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = `/${t15}/${props.contentTrack.slug}`;
  let t17;
  if ($[26] !== getBreakpointValue) {
    t17 = getBreakpointValue(["sm", "lg", "lg", "md", "lg"]);
    $[26] = getBreakpointValue;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <ChevronRightIcon />;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== ref || $[30] !== t17) {
    t19 = <Button ref={ref} as="span" size={t17} variant="outline">Overview{t18}</Button>;
    $[29] = ref;
    $[30] = t17;
    $[31] = t19;
  } else {
    t19 = $[31];
  }
  let t20;
  if ($[32] !== t16 || $[33] !== t19) {
    t20 = <NextLink href={t16}>{t19}</NextLink>;
    $[32] = t16;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== props.contentTrack) {
    t21 = getTrackPathPrefix(props.contentTrack);
    $[35] = props.contentTrack;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  const t22 = `/${t21}/${props.contentTrack.slug}/${props.contentTrack.sections[0]?.slug}/${props.contentTrack.sections[0]?.steps[0]?.slug}`;
  const t23 = `${props.contentTrack.color?.hex}`;
  let t24;
  if ($[37] !== getBreakpointValue) {
    t24 = getBreakpointValue(["sm", "lg", "lg", "md", "lg"]);
    $[37] = getBreakpointValue;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <ChevronRightIcon />;
    $[39] = t25;
  } else {
    t25 = $[39];
  }
  let t26;
  if ($[40] !== ref || $[41] !== t23 || $[42] !== t24) {
    t26 = <Button ref={ref} as="span" bgColor={t23} size={t24}>Begin Course{t25}</Button>;
    $[40] = ref;
    $[41] = t23;
    $[42] = t24;
    $[43] = t26;
  } else {
    t26 = $[43];
  }
  let t27;
  if ($[44] !== t22 || $[45] !== t26) {
    t27 = <NextLink href={t22}>{t26}</NextLink>;
    $[44] = t22;
    $[45] = t26;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== t20 || $[48] !== t27) {
    t28 = <Stack align="center" direction="row" gap={4}>{t20}{t27}</Stack>;
    $[47] = t20;
    $[48] = t27;
    $[49] = t28;
  } else {
    t28 = $[49];
  }
  let t29;
  if ($[50] !== t14 || $[51] !== t28) {
    t29 = <FadeRevealWithSSR cascade={true} damping={0.5} direction="up" duration={500} triggerOnce={true}>{t14}{t28}</FadeRevealWithSSR>;
    $[50] = t14;
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  let t30;
  if ($[53] !== t29 || $[54] !== t8 || $[55] !== t9) {
    t30 = <VStack align="flex-start" flex={2} gap={8} justify="center" paddingX={t8} paddingY={t9}>{t29}</VStack>;
    $[53] = t29;
    $[54] = t8;
    $[55] = t9;
    $[56] = t30;
  } else {
    t30 = $[56];
  }
  let t31;
  if ($[57] !== props.direction || $[58] !== t30 || $[59] !== t7) {
    t31 = <Stack direction={t3} gap={0} justify="center" position="relative" width="full">{t7}{t30}</Stack>;
    $[57] = props.direction;
    $[58] = t30;
    $[59] = t7;
    $[60] = t31;
  } else {
    t31 = $[60];
  }
  let t32;
  if ($[61] !== props.fadeDir || $[62] !== t1 || $[63] !== t2 || $[64] !== t31) {
    t32 = <VStack align="center" bgGradient={t0} borderRadius="2xl" borderTopStyle="solid" borderTopWidth="1px" boxShadow="md" gradientFrom={t1} gradientTo={t2} overflow="hidden" width="full">{t31}</VStack>;
    $[61] = props.fadeDir;
    $[62] = t1;
    $[63] = t2;
    $[64] = t31;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  return t32;
};
ContentTrackCard.fragments = {
  ContentTrack: () => gql`
    fragment _ on ContentTrack {
      id
      title
      slug
      type
      shortDescription
      terms {
        id
        name
      }
      featuredImage {
        id
        url(transformation: { image: { resize: { fit: max, width: 1000 } } })
      }
      terms {
        id
        name
      }
      sections {
        id
        slug
        steps {
          id
          slug
          tasks {
            id
          }
        }
      }
    }
  `
};